import React from "react";

import { EnvironmentsAPI } from "@providers/EnvironmentsAPI";
import { Button } from "../../components/Button";
import { Drawer } from "../../components/Drawer";
import { Loading } from "../../components/Loading";
import { Select } from "../../components/Select";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import styles from "@styles/integrations.module.scss"
import { Context } from "pages/Integrations";
import { Label } from "@components";
import { NumberInput } from "shared/components/NumberInput";

export default class NewChoiceDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loading: false,
      environment: "PRODUCTION",
      command_range: { min: null, max: null }
    };
  }

  componentDidMount() {
    this.loadConfigs();
  }

  async loadConfigs() {
    const environmentId = EnvironmentStorage.getEnvironment().id;

    const externalCredentials = await EnvironmentsAPI.getConfigurationsByAlias(
      environmentId,
      "external_credentials"
    );
    const ecleticaConfigs = externalCredentials.new_choice || {};

    if (Object.keys(ecleticaConfigs).length > 0) {
      this.setState({
        environment: ecleticaConfigs.environment,
        command_range: ecleticaConfigs.command_range,
      });
    }

    this.setState({ loadingPage: false, });
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const { environment, command_range } = this.state;

      this.setState({ loading: true });

      const environmentId = EnvironmentStorage.getEnvironment().id;

      const externalCredentials = await EnvironmentsAPI.getConfigurationsByAlias(
        environmentId,
        "external_credentials"
      );

      const payload = {
        ...externalCredentials,
        new_choice: {
          environment,
          command_range
        },
      };

      const updateResponse = await EnvironmentsAPI.putConfigurationsByAlias(
        environmentId,
        "external_credentials",
        payload
      );

      this.setState({ loading: false });

      if (updateResponse.getErrors([]).length === 0) {
        onSave && onSave();
      } else {
        alert({
          text: `Não foi possível alterar a configuração: ${updateResponse.getErrors()[0]
            }`,
        });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  render() {
    const { loading, loadingPage, environment, command_range } =
      this.state;
    const { visible, onClose } = this.props;

    const isValid = environment;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title={"New Choice"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.onSave()}
            loading={loading}
            disabled={loading || !isValid}
          >
            Salvar alterações
          </Button>
        }
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <Select
              design="two"
              label="Ambiente"
              onChange={(e) => this.setState({ environment: e.target.value })}
              className="mb-20"
              value={environment}
              options={[
                {
                  label: "Produção",
                  value: "PRODUCTION",
                  selected: environment === "PRODUCTION",
                },
                {
                  label: "Homologação",
                  value: "SANDBOX",
                  selected: environment === "SANDBOX",
                },
              ]}
            />

            <Label>Faixa das comandas</Label>
            <div className="w-100 d-flex">
              <NumberInput
                design="two"
                className="mb-20 w-50"
                floatLabel="Min."
                value={command_range?.min}
                onChange={(e) => this.setState({ command_range: { ...this.command_range, min: e.target.value } })}
              />
              <NumberInput
                design="two"
                className="mb-20 w-50"
                floatLabel="Máx."
                value={command_range?.max}
                onChange={(e) => this.setState({ command_range: { ...this.command_range, max: e.target.value } })}
              />
            </div>

          </div>
        )}
      </Drawer>
    );
  }
}
